const carouselItems = [
  {
    title: '暑期档重磅推荐',
    subtitle: '20 部不可错过的夏日大片',
    desc: '从好莱坞巨制到国产精品，窝窝影院为您精选暑期最值得观看的电影清单。高清播放在线不缓冲，炎炎夏日宅家也能享受影院级观影体验。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20movie%20collage%20with%20warm%20golden%20sunset%20colors%2C%20film%20strip%20elements%2C%20dramatic%20lighting%2C%20epic%20cinema%20atmosphere%2C%20professional%20movie%20poster%20composition%2C%20rich%20warm%20tones&width=1600&height=700&seq=carousel-summer-01&orientation=landscape',
    badge: '热门专题',
  },
  {
    title: '国漫崛起 · 匠心之作',
    subtitle: '见证中国动画的黄金时代',
    desc: '从《哪吒之魔童降世》到《深海》《长安三万里》，国产动画正以惊人的速度崛起。窝窝影院整理国漫发展历程与必看片单，流畅观看超清画质无广告。',
    img: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20animation%20art%20style%20scene%20with%20traditional%20ink%20painting%20elements%20and%20modern%20cinematic%20lighting%2C%20warm%20golden%20and%20red%20tones%2C%20epic%20fantasy%20atmosphere%2C%20artistic%20composition&width=1600&height=700&seq=carousel-anime-02&orientation=landscape',
    badge: '国漫专题',
  },
  {
    title: '经典修复 · 高清重现',
    subtitle: '100 部影史经典 4K 修复版上线',
    desc: '致敬电影艺术，《教父》《肖申克的救赎》《霸王别姬》等经典影片高清修复版陆续上线窝窝影院。海量高清电影电视剧免费在线观看，重温光影传奇。',
    img: 'https://readdy.ai/api/search-image?query=Vintage%20Hollywood%20cinema%20aesthetic%20with%20classic%20film%20elements%2C%20warm%20sepia%20and%20golden%20tones%2C%20nostalgic%20movie%20atmosphere%2C%20elegant%20old%20film%20texture%2C%20dramatic%20lighting%2C%20timeless%20cinema%20photography&width=1600&height=700&seq=carousel-classic-03&orientation=landscape',
    badge: '经典修复',
  },
  {
    title: '科幻盛宴 · 未来已来',
    subtitle: '全球科幻影视巅峰作品合集',
    desc: '从《三体》到《流浪地球》，从《星际穿越》到《沙丘》，窝窝影院打造最全科幻片库。每日更新不卡顿，沉浸式体验科幻世界的无限想象。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20futuristic%20sci-fi%20cityscape%20with%20neon%20lights%20and%20floating%20structures%2C%20cinematic%20atmosphere%2C%20dramatic%20lighting%20with%20warm%20and%20cool%20tone%20contrast%2C%20film%20poster%20aesthetic%2C%20grand%20scale%20composition&width=1600&height=700&seq=carousel-scifi-04&orientation=landscape',
    badge: '科幻盛宴',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-3 whitespace-nowrap">
            焦点专题
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            重磅策划 · 深度专题
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="relative bg-background-100 rounded-xl overflow-hidden group cursor-pointer"
            >
              <div className="relative overflow-hidden h-48 md:h-56">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={item.title}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                <div className="absolute top-4 left-4">
                  <span className="inline-block px-2.5 py-0.5 rounded-full text-[10px] font-medium bg-accent-500 text-background-50 whitespace-nowrap">
                    {item.badge}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading font-bold text-foreground-900 text-lg mb-1">
                  {item.title}
                </h3>
                <p className="text-primary-600 text-sm font-medium mb-2">
                  {item.subtitle}
                </p>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}